import type { IsoDate, LogMap } from "./types.js";
import { addDays, weekdayOf } from "./dates.js";
import { PLAN_END, PLAN_START } from "./plan.js";
import { longRunKm, workoutFor } from "./workout.js";

/**
 * 首頁的本週課表進度與本週長跑。週一到週日為一週，只算賽季內的日子。
 *
 * **公里數是課表上的安排，不是實際跑了多少。** App 沒有跑步距離的資料，輕鬆跑又
 * 是用分鐘計，所以刻意不顯示「本週跑量」。完成與否一律看課表有沒有打勾。
 *
 * 與 `src/domain/` 的鐵則一致：「今天」由呼叫端傳入。
 */

export interface WeekPlan {
  /** 本週已打勾的課表天數。 */
  done: number;
  /** 本週在賽季內的天數。開賽那週少於 7 天。 */
  total: number;
  /** 本週的長跑。每週都有一天，最後一週是比賽本身。 */
  longRun: { date: IsoDate; km: number; done: boolean; race: boolean };
}

export function weekPlan(logs: LogMap, date: IsoDate): WeekPlan {
  // weekdayOf 的週日是 0，這裡的一週從週一開始
  const monday = addDays(date, -((weekdayOf(date) + 6) % 7));
  const days: IsoDate[] = [];
  for (let offset = 0; offset < 7; offset++) {
    const day = addDays(monday, offset);
    if (day >= PLAN_START && day <= PLAN_END) days.push(day);
  }

  const longRunDate = days.find(day => workoutFor(day)[2] === "longrun") as IsoDate;

  return {
    done: days.filter(day => !!logs[day]?.workout_done).length,
    total: days.length,
    longRun: {
      date: longRunDate,
      km: longRunKm(longRunDate),
      done: !!logs[longRunDate]?.workout_done,
      race: longRunDate === PLAN_END
    }
  };
}
